import React, { useCallback } from 'react';
// import cn from 'classnames';
import { Button, message, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useRemoveTutorWorkExperienceMutation } from '../../store/apis/administratives/tutors';
import useToggle from '../../hooks/useToggle';

const RemoveWorkExperience = ({ id }) => {
  const [t] = useTranslation();
  const [isOpen, open, close] = useToggle();
  const [remove, { isLoading, isFetching }] = useRemoveTutorWorkExperienceMutation();

  const removeEducation = useCallback(async () => {
    try {
      await remove(id).unwrap();
      message.success(t('Опыт работы удален'));
      close();
    } catch (e) {
      console.log(JSON.stringify(e, 0, 2));
    }
  }, [close, id, remove, t]);

  return (
    <Popconfirm
      open={isOpen}
      title={t('Вы действительно хотите удалить опыт работы?')}
      description={t('Данное действие необратимо')}
      okText={t('Да, удалить')}
      cancelText={t('Нет')}
      onConfirm={removeEducation}
      onCancel={close}
      okButtonProps={{
        loading: isLoading || isFetching,
      }}
    >
      <Button type="link" danger icon={<DeleteOutlined />} size="small" onClick={open}/>
    </Popconfirm>
  );
};

export default RemoveWorkExperience;
